import React from "react";

const MAP = {
  ricevuto: { label: "Ricevuto", color: "#1C1B1A", bg: "#E4DFD5" },
  in_lavorazione: { label: "In lavorazione", color: "#1C1B1A", bg: "#DFBE73" },
  pronto: { label: "Pronto", color: "#fff", bg: "#4A6B53" },
  spedito: { label: "Spedito", color: "#fff", bg: "#5C7C8A" },
  consegnato: { label: "Consegnato", color: "#fff", bg: "#1C1B1A" },
  annullato: { label: "Annullato", color: "#fff", bg: "#9E413B" },
  pending: { label: "In attesa", color: "#1C1B1A", bg: "#E4DFD5" },
  paid: { label: "Pagato", color: "#fff", bg: "#4A6B53" },
};

export default function StatusBadge({ status, testId }) {
  const m = MAP[status] || { label: status, color: "#1C1B1A", bg: "#E4DFD5" };
  return (
    <span className="status-pill" style={{ background: m.bg, color: m.color }} data-testid={testId || `status-${status}`}>
      <span className="dot" style={{ background: m.color, opacity: 0.5 }} />
      {m.label}
    </span>
  );
}
